import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box, Stack} from '@dropbox/dig-foundations';
import {ReactNode, useId} from 'react';

/** One bordered report card: a title (and optional subtitle / right-side summary) over its body. */
export const WireframeSection = ({
  title,
  subtitle,
  aside,
  children,
}: {
  title: string;
  subtitle?: string;
  aside?: ReactNode;
  children: ReactNode;
}) => {
  const titleId = useId();
  return (
    <section
      aria-labelledby={titleId}
      className={atoms({
        borderColor: 'Border Subtle',
        borderStyle: 'Solid',
        borderWidth: '1',
        borderRadius: 'Medium',
        padding: '16',
        minWidth: '0',
      })}
    >
      <Stack gap="16">
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" columnGap="16">
          <Stack gap="4">
            <Text id={titleId} tagName="h3" size="large" isBold>
              {title}
            </Text>
            {subtitle && (
              <Text size="small" color="subtle">
                {subtitle}
              </Text>
            )}
          </Stack>
          {aside}
        </Box>
        {children}
      </Stack>
    </section>
  );
};
